import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class CryptoUtilityService {

  async toBase64(bytes: Uint8Array): Promise<string> {
    const normalizedBytes = new Uint8Array(bytes);
    const arrayBuffer = normalizedBytes.buffer.slice(
      normalizedBytes.byteOffset,
      normalizedBytes.byteOffset + normalizedBytes.byteLength
    );

    const dataUrl = await new Promise<string>((resolve, reject) => {
      const reader = new FileReader();
      reader.onload = () => {
        if (typeof reader.result === 'string') {
          resolve(reader.result);
        } else {
          reject(new Error('Invalid FileReader result type for base64 conversion'));
        }
      };
      reader.onerror = () => reject(reader.error ?? new Error('Failed to convert bytes to base64'));
      reader.readAsDataURL(new Blob([arrayBuffer], { type: 'application/pdf' }));
    });

    const commaIndex = dataUrl.indexOf(',');
    return commaIndex >= 0 ? dataUrl.substring(commaIndex + 1) : dataUrl;
  }

}
